import { render, staticRenderFns } from "./ShowModalityMainData.vue?vue&type=template&id=7d64216a&scoped=true"
import script from "./ShowModalityMainData.vue?vue&type=script&lang=js"
export * from "./ShowModalityMainData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64216a",
  null
  
)

export default component.exports